module.exports = __webpack_public_path__ + "static/media/Speech-to-text.50900978.png";